import { render, staticRenderFns } from "./HomePageNew.vue?vue&type=template&id=52f6066e&scoped=true"
import script from "./HomePageNew.vue?vue&type=script&lang=js"
export * from "./HomePageNew.vue?vue&type=script&lang=js"
import style0 from "../../styles/home-page-new.scss?vue&type=style&index=0&id=52f6066e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f6066e",
  null
  
)

export default component.exports